<template>
  <div class="container">
    <img src="https://zk-web-source.oss-cn-beijing.aliyuncs.com/job-exam/top_img_360.png" alt="" class="top-img" v-if="$route.params.orign == 360" />
    <img src="https://zk-web-source.oss-cn-beijing.aliyuncs.com/job-exam/top_img.png" alt="" class="top-img" v-else />
    <div class="header">
      <div class="w1200">
        <ul>
          <li v-for="(item, index) in navigation" :key="index" :class="{ on: item.key === currentNav }" @click="setScrollEvent(item.key)">
            {{ item.name }}
          </li>
        </ul>
      </div>
    </div>
    <div id="xxzy">
      <el-carousel height="561px" arrow="never">
        <el-carousel-item>
          <img src="https://zk-web-source.oss-cn-beijing.aliyuncs.com/job-exam/banner_01.png" alt="" />
        </el-carousel-item>
        <el-carousel-item>
          <img src="https://zk-web-source.oss-cn-beijing.aliyuncs.com/job-exam/banner_02.png" alt="" />
        </el-carousel-item>
        <el-carousel-item>
          <img src="https://zk-web-source.oss-cn-beijing.aliyuncs.com/job-exam/banner_03.png" alt="" />
        </el-carousel-item>
      </el-carousel>
    </div>
    <div id="tzgg" v-if="$route.params.orign != 360">
      <div class="w1200">
        <img src="https://zk-web-source.oss-cn-beijing.aliyuncs.com/job-exam/zsdt.png" alt="" style="width: 671" @click="noticeVisible = true" />
        <img src="https://zk-web-source.oss-cn-beijing.aliyuncs.com/job-exam/tzgg.png" alt="" style="width: 509px" @click="noticeVisible = true" />
      </div>
    </div>
    <div id="yxzy">
      <h2>热门专业/招生简章</h2>
      <div class="w1200">
        <ul>
          <li v-for="(item, index) in hotMajors" :key="index">
            <img :src="`https://zk-web-source.oss-cn-beijing.aliyuncs.com/job-exam/hot_li_0${index + 1}.png`" alt="" />
            <div class="content">
              <span class="title">{{ item }}</span>
              <div class="rule" @click="hotVisible = true">招生简章</div>
              <div class="range" @click="hotVisible = true">学费区间</div>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <div id="zszz">
      <img src="https://zk-web-source.oss-cn-beijing.aliyuncs.com/job-exam/entro_car_bg.png" alt="" class="bg" />
      <div class="w1200">
        <img src="https://zk-web-source.oss-cn-beijing.aliyuncs.com/job-exam/entro_car_small.png" alt="" />
        <div class="info">
          <p>勾选想要了解的方面：</p>
          <ul>
            <li v-for="(item, index) in enrollmentList" :key="index" :class="item.isChecked ? 'on' : ''" @click="enrollmentClick(index)">
              {{ item.name }}
            </li>
          </ul>
          <p>联系方式：</p>
          <input type="text" maxlength="20" placeholder="请输入您的电话号码" v-model="enrollMobile" />
          <a href="" @click.prevent="enrollmentSubmit">获取报考/招生信息</a>
        </div>
      </div>
    </div>
    <div id="bkzc">
      <h3 class="common-title">
          <template v-if="$route.params.orign == 360">
              在职研究生<span>招生信息栏</span></span>
          </template>
          <template v-else>
              在职研究生<span>招生政策专区</span>
          </template>
      </h3>
      <div class="w1200">
        <ul>
          <li style="width: 356px; height: 270px" @click="noticeVisible = true">
            <img src="https://zk-web-source.oss-cn-beijing.aliyuncs.com/job-exam/zszz_li_01.png" alt="" style="cursor: pointer" />
          </li>
          <li style="width: 823px; height: 270px" @click="noticeVisible = true">
            <img src="https://zk-web-source.oss-cn-beijing.aliyuncs.com/job-exam/zszz_li_02_360.png" alt="" v-if="$route.params.orign == 360" />
            <img src="https://zk-web-source.oss-cn-beijing.aliyuncs.com/job-exam/zszz_li_02.png" alt="" v-else />
          </li>
          <li style="width: 356px; height: 291px">
            <img src="https://zk-web-source.oss-cn-beijing.aliyuncs.com/job-exam/zszz_li_03.png" alt="" />
            <div class="sub-box" @click="noticeVisible = true">
              <span>报读条件 >></span>
              <span>报读资料 >></span>
              <span>学历要求 >></span>
              <span>院校学费 >></span>
              <span>报读政策 >></span>
              <span>报考流程 >></span>
              <span>工作年限 >></span>
              <span>英语要求 >></span>
            </div>
          </li>
          <li style="width: 401px; height: 291px" @click="noticeVisible = true">
            <img src="https://zk-web-source.oss-cn-beijing.aliyuncs.com/job-exam/zszz_li_04_360.png" alt="" v-if="$route.params.orign == 360" />
            <img src="https://zk-web-source.oss-cn-beijing.aliyuncs.com/job-exam/zszz_li_04.png" alt="" v-else />
          </li>
          <li style="width: 401px; height: 291px" @click="noticeVisible = true">
            <img src="https://zk-web-source.oss-cn-beijing.aliyuncs.com/job-exam/zszz_li_05_360.png" alt="" v-if="$route.params.orign == 360" />
            <img src="https://zk-web-source.oss-cn-beijing.aliyuncs.com/job-exam/zszz_li_05.png" alt="" v-else />
          </li>
        </ul>
      </div>
    </div>
    <div class="box3">
      <h3 class="common-title">在职研<span>报考流程</span></h3>
      <div class="w1200">
        <img src="https://zk-web-source.oss-cn-beijing.aliyuncs.com/job-exam/progress_icon.png" alt="" class="l-img" />
        <div class="form">
          <p>您的学历</p>
          <el-radio-group v-model="edu">
            <el-radio label="专科">专科</el-radio>
            <el-radio label="成人本科">成人本科</el-radio>
            <el-radio label="全日制本科">全日制本科</el-radio>
            <el-radio label="自考本科">自考本科</el-radio>
          </el-radio-group>
          <p>毕业年限</p>
          <el-radio-group v-model="graduate">
            <el-radio label="应届生">应届生</el-radio>
            <el-radio label="3-5年">3-5年</el-radio>
            <el-radio label="1-3年">1-3年</el-radio>
            <el-radio label="5年以上">5年以上</el-radio>
          </el-radio-group>
          <p>联系方式</p>
          <input type="text" placeholder="请输入您的电话号码" maxlength="20" v-model="flowMobile" />
          <a href="" @click.prevent="flowSubmit">审核报名条件</a>
        </div>
      </div>
    </div>
    <div id="zlxz">
      <h3 class="common-title">在职研<span>资料专区</span></h3>
      <div class="w1200">
        <p class="hint">研究生报考复习资料，仅供<span>报考学生免费使用</span>，请勿进行二次传播</p>
        <div class="zl-form">
          <img src="https://zk-web-source.oss-cn-beijing.aliyuncs.com/job-exam/lqzl_img.png" alt="" />
          <div class="r-box">
            <img src="https://zk-web-source.oss-cn-beijing.aliyuncs.com/job-exam/zl_free_img.png" alt="" />
            <input type="text" placeholder="请输入手机号（必填）" maxlength="20" v-model="zlMobile" />
            <a href="" @click.prevent="zlSubmit">立即获取资料</a>
          </div>
        </div>
      </div>
    </div>
    <div class="footer">
      <div class="w1200">
        <ul>
          <li><a href="" @click.prevent="noticeVisible = true">关于我们</a> &nbsp;&nbsp;<span>|</span>&nbsp;&nbsp;</li>
          <li><a href="" @click.prevent="noticeVisible = true">公司官网</a> &nbsp;&nbsp;;<span>|</span>&nbsp;&nbsp</li>
          <li><a href="" @click.prevent="noticeVisible = true">用户协议</a> &nbsp;&nbsp;<span>|</span>&nbsp;&nbsp;</li>
          <li><a href="" @click.prevent="noticeVisible = true">隐私政策</a> &nbsp;&nbsp;<span>|</span>&nbsp;&nbsp;</li>
          <li><a href="" @click.prevent="noticeVisible = true">免责声明</a> &nbsp;&nbsp;<span>|</span>&nbsp;&nbsp;</li>
          <li><a href="" @click.prevent="noticeVisible = true">App下载</a> &nbsp;&nbsp;<span>|</span>&nbsp;&nbsp;</li>
          <li>
            <a href="" @click.prevent="noticeVisible = true">账号注册</a>
            &nbsp;&nbsp;<span>|</span>&nbsp;&nbsp;
          </li>
          <li>
            <a href="" @click.prevent="noticeVisible = true">购买课程</a>
            &nbsp;&nbsp;<span>|</span>&nbsp;&nbsp;
          </li>
          <li>
            <a href="" @click.prevent="noticeVisible = true">如何学习</a>
            &nbsp;&nbsp;<span>|</span>&nbsp;&nbsp;
          </li>
          <li><a href="" @click.prevent="noticeVisible = true">问题反馈</a> &nbsp;&nbsp;</li>
        </ul>
        <template v-if="$route.params.orign != 360">
          <div class="line"></div>
          <div class="copyright">
            <a href="https://beian.miit.gov.cn/" rel="nofollow" target="_blank">豫ICP备2021007352号</a> &nbsp;&nbsp;
            <a href="" @click.prevent="noticeVisible = true">中课网校</a>&nbsp;&nbsp;
            <a href="" @click.prevent="noticeVisible = true">网站地图</a>
          </div>
        </template>
      </div>
    </div>
    <!-- 资讯弹框 -->
    <Dialog class="zx-dialog" :visible.sync="infoVisible" center :show-close="false" width="620px">
      <div class="content">
        <img src="https://zk-web-source.oss-cn-beijing.aliyuncs.com/job-exam/zx_dialog_bg.png" alt="" class="dialog-bg" />
        <img src="https://zk-web-source.oss-cn-beijing.aliyuncs.com/job-exam/close.png" class="close" @click="infoVisible = false" />
        <h3>资讯页面获取入口</h3>
        <div class="radio-box">
          <el-radio-group v-model="infoType">
            <el-radio label="公开课">公开课</el-radio>
            <el-radio label="直播课">直播课</el-radio>
            <el-radio label="选课中心">选课中心</el-radio>
            <el-radio label="题库中心">题库中心</el-radio>
            <el-radio label="最新资讯">最新资讯</el-radio>
            <el-radio label="APP下载">APP下载</el-radio>
          </el-radio-group>
        </div>
        <div class="input-box">
          <input type="text" placeholder="您的姓名" class="name" v-model="zxName" maxlength="20" />
          <input type="text" placeholder="请输入您的电话号码" class="mobile" v-model="zxMobile" maxlength="20" />
          <a href="" @click.prevent="zxSubmit">立即获取</a>
        </div>
        <p><span>*</span>手机号已加密，仅供获取招生简章/学费区间使用，请放心填写！</p>
      </div>
    </Dialog>

    <!-- 通知弹框 -->
    <Dialog class="notice-dialog" :visible.sync="noticeVisible" center :show-close="false" width="636px">
      <div class="content">
        <img src="https://zk-web-source.oss-cn-beijing.aliyuncs.com/job-exam/zx_dialog_bg.png" alt="" class="dialog-bg" />
        <img src="https://zk-web-source.oss-cn-beijing.aliyuncs.com/job-exam/close.png" class="close" @click="noticeVisible = false" />
        <h3>关于考研，你想了解什么？</h3>
        <p><span>*</span>勾选你想了解的内容获取考研信息，可多选</p>

        <div class="check-boxs">
          <el-checkbox-group v-model="noticeList">
            <el-checkbox label="招生简章">招生简章</el-checkbox>
            <el-checkbox label="录取比例">录取比例</el-checkbox>
            <el-checkbox label="报考条件">报考条件</el-checkbox>
            <el-checkbox label="报考流程">报考流程</el-checkbox>
            <el-checkbox label="年限要求">年限要求</el-checkbox>
            <el-checkbox label="报读政策">报读政策</el-checkbox>

            <el-checkbox label="学院学费">学院学费</el-checkbox>
            <el-checkbox label="历年分数线">历年分数线</el-checkbox>
            <el-checkbox label="英语要求">英语要求</el-checkbox>
            <el-checkbox label="报读资料">报读资料</el-checkbox>
            <el-checkbox label="考研资料领取"
              ><span>考研资料领取<img src="https://zk-web-source.oss-cn-beijing.aliyuncs.com/job-exam/hot_icon.png" alt="" /></span
            ></el-checkbox>
          </el-checkbox-group>
        </div>
        <div class="input-box">
          <input type="text" placeholder="联系方式：（请输入您的手机号，已加密）" class="mobile" v-model="noticeMobile" maxlength="20" />
          <a href="" @click.prevent="noticeSubmit">一键了解详情 ＞＞</a>
        </div>
      </div>
    </Dialog>

    <!-- 热门专业弹框 -->
    <Dialog class="hot-dialog" :visible.sync="hotVisible" center :show-close="false" width="620px" destroy-on-close>
      <div class="content">
        <img src="https://zk-web-source.oss-cn-beijing.aliyuncs.com/job-exam/close_icon.png" class="close" @click="hotVisible = false" />

        <img src="https://zk-web-source.oss-cn-beijing.aliyuncs.com/job-exam/hot_dialog_top.png" alt="" class="top-img" />
        <h3>热门专业/招生简章获取页面！</h3>
        <div class="input-box" style="margin-top: 55px">
          姓名：<input type="text" placeholder="请输入您的姓名" class="name" v-model="majorName" maxlength="20" />
        </div>
        <div class="input-box">电话： <input type="text" placeholder="请输入您的电话号码" class="mobile" v-model="majorMobile" maxlength="20" /></div>
        <p><span>*</span>手机号已加密，仅供获取招生简章/学费区间使用，请放心填写！</p>
        <a href="" @click.prevent="majorSubmit">立即获取＞＞</a>
      </div>
    </Dialog>

    <!-- 提交成功提示 -->
    <Dialog class="submit-dialog" title="提交成功！" :visible.sync="successVisible" center :show-close="false" width="460px">
      <div class="submitMian">
        报考老师将于24小时内和你联系
        <br />
        请注意接听！
      </div>
      <span slot="footer" class="dialog-footer">
        <button @click="successVisible = false">确定</button>
      </span>
    </Dialog>
  </div>
</template>
<script>
import { Dialog } from 'element-ui'
import { Message } from 'element-ui'
import md5 from 'js-md5'
import { graduatePromot } from '@/api/index'
import { phoneValidator } from '@/utils'
export default {
  data() {
    return {
      navigation: [
        { name: '学校主页', key: 'xxzy' },
        { name: '院校专业', key: 'yxzy' },
        { name: '报考政策', key: 'bkzc' },
        { name: '招生咨询', key: 'zszz' },
        { name: '通知公告', key: 'tzgg' },
        { name: '资料下载', key: 'zlxz' }
      ],
      hotMajors: ['工商管理（MBA）', '临床医学', '护理学', '心理学', '土木工程', '公共管理', '教育学', '工程管理'],
      currentNav: 'xxzy',
      hotVisible: false,
      infoVisible: false,
      successVisible: false,
      noticeVisible: false,
      //学历
      edu: '',
      //毕业年限
      graduate: '',
      enrollmentList: [
        { name: '招生简章', isChecked: false },
        { name: '报考条件', isChecked: false },
        { name: '录取比例', isChecked: false },
        { name: '学院学费', isChecked: false },
        { name: '历年分数线', isChecked: false },
        { name: '英语要求', isChecked: false }
      ],
      //招生报考直通车手机号
      enrollMobile: '',
      //在职研报考流程
      flowMobile: '',
      //在职研资料专区手机号
      zlMobile: '',
      //热门专业/招生简章
      majorName: '',
      majorMobile: '',
      //资讯页面获取入口
      zxName: '',
      zxMobile: '',
      //资讯页面获取入口
      infoType: '',
      //通知公共
      noticeMobile: '',
      noticeList: []
    }
  },
  components: {
    Dialog
  },
  methods: {
    setScrollEvent(id) {
      this.currentNav = id
      if (this.$route.params.orign == 360) {
        if (this.currentNav == 'tzgg') {
          this.noticeVisible = true
          return
        }
      }
      $('html,body').animate({ scrollTop: $(`#${id}`).offset().top }, 0)
    },
    enrollmentClick(index) {
      this.enrollmentList[index].isChecked = !this.enrollmentList[index].isChecked
    },
    //招生报考直通车
    enrollmentSubmit() {
      const checkedList = this.enrollmentList.filter(item => item.isChecked)
      if (!checkedList.length) {
        return Message.warning('请勾选想要了解的方面')
      }
      if (!this.enrollMobile.length) {
        return Message.warning('请输入您的电话号码')
      }
      if (!phoneValidator(this.enrollMobile)) {
        return Message.warning('手机号格式错误')
      }

      const params = {
        mobile: this.enrollMobile,
        remark: `了解内容:${checkedList.map(item => item.name).join('、')}`
      }
      this.onSubmit(params)
    },
    //在职研 报考流程
    flowSubmit() {
      if (!this.edu.length) {
        return Message.warning('请选择学历')
      }
      if (!this.graduate.length) {
        return Message.warning('请选择毕业年限')
      }
      if (!this.flowMobile.length) {
        return Message.warning('请输入您的电话号码')
      }
      if (!phoneValidator(this.flowMobile)) {
        return Message.warning('手机号格式错误')
      }

      const params = {
        mobile: this.flowMobile,
        remark: `学历:${this.edu}，毕业年限:${this.graduate}`
      }
      this.onSubmit(params)
    },
    //在职研资料专区
    zlSubmit() {
      if (!this.zlMobile.length) {
        return Message.warning('请输入您的电话号码')
      }
      if (!phoneValidator(this.zlMobile)) {
        return Message.warning('手机号格式错误')
      }

      const params = {
        mobile: this.zlMobile
      }
      this.onSubmit(params)
    },
    //热门专业/招生简章
    majorSubmit() {
      if (!this.majorName.length) {
        return Message.warning('请输入您的姓名')
      }
      if (!this.majorMobile.length) {
        return Message.warning('请输入您的电话号码')
      }
      if (!phoneValidator(this.majorMobile)) {
        return Message.warning('手机号格式错误')
      }
      const params = {
        name: this.majorName,
        mobile: this.majorMobile
      }
      this.onSubmit(params)
    },
    //资讯页面获取入口
    zxSubmit() {
      if (!this.infoType.length) {
        return Message.warning('请选择资讯获取入口')
      }
      if (!this.zxName.length) {
        return Message.warning('请输入您的姓名')
      }

      if (!this.zxMobile.length) {
        return Message.warning('请输入您的电话号码')
      }
      if (!phoneValidator(this.zxMobile)) {
        return Message.warning('手机号格式错误')
      }

      const params = {
        name: this.zxName,
        mobile: this.zxMobile,
        remark: `资讯页面获取入口:${this.infoType}`
      }
      this.onSubmit(params)
    },
    noticeSubmit() {
      if (!this.noticeList.length) {
        return Message.warning('请勾选想了解的内容')
      }

      if (!this.noticeMobile.length) {
        return Message.warning('请输入联系方式')
      }

      if (!phoneValidator(this.noticeMobile)) {
        return Message.warning('手机号格式错误')
      }
      const params = {
        mobile: this.noticeMobile,
        remark: `通知公告:${this.noticeList.join(',')}`
      }
      this.onSubmit(params)
    },
    onSubmit(params) {
      const gt = new Date().getTime().toString()
      graduatePromot({
        ...params,
        time: gt,
        encryPwd: md5(gt + 'verify'),
        collegeName: '专业课',
        orign: this.$route.params.orign == 'baidu' ? '百度信息流' : '360搜索',
        promotedAccount: this.$route.params.orign == 'baidu' ? '中课网校13-D' : '360-考研-D'
      }).then(res => {
        this.successVisible = true
        this.hotVisible = false
        this.infoVisible = false
        this.noticeVisible = false
        this.edu = ''
        this.graduate = ''
        this.enrollMobile = ''
        this.flowMobile = ''
        this.zlMobile = ''
        this.majorName = ''
        this.majorMobile = ''
        this.zxName = ''
        this.zxMobile = ''
        this.infoType = ''
        this.noticeMobile = ''
        this.noticeList = ''
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.container {
  .top-img {
    width: 100%;
    height: 160px;
    vertical-align: bottom;
    object-fit: cover;
  }
  .header {
    background: #1787e0;
    ul {
      display: flex;
      align-items: center;
      justify-content: space-between;
      height: 60px;
      li {
        flex: 1;
        color: #ffffff;
        font-size: 16px;
        display: flex;
        justify-content: center;
        align-items: center;
        height: 100%;
        cursor: pointer;
        &.on {
          position: relative;
          background: #0045ad;
          font-weight: bold;
          &:after {
            position: absolute;
            left: 50%;
            content: '';
            width: 65px;
            height: 1px;
            background: #f6f8fe;
            bottom: 15px;
            transform: translateX(-50%);
          }
        }
      }
    }
  }
  #xxzy {
    margin-top: -1px;
    ::v-deep .el-carousel__indicator {
      .el-carousel__button {
        width: 10px;
        height: 10px;
        border-radius: 50%;
      }
    }
    ::v-deep .el-carousel__item {
      img {
        height: 100%;
        width: 100%;
        object-fit: cover;
      }
    }
  }

  #tzgg {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-top: 40px;
    height: 390px;
    background: #f6f8fe;
    .w1200 {
      display: flex;
      justify-content: space-between;
      img {
        height: 311px;
        cursor: pointer;
      }
    }
  }
  #yxzy {
    background: #ffffff;
    height: 832px;
    h2 {
      text-align: center;
      padding-top: 74px;
      padding-bottom: 10px;
      color: #333333;
      font-size: 26px;
      font-weight: bold;
    }
    ul {
      display: flex;
      flex-wrap: wrap;
      li {
        position: relative;
        width: 284px;
        height: 270px;
        margin-top: 46px;
        &:not(:nth-child(4n)) {
          margin-right: 21px;
        }
        & > img {
          position: absolute;
          width: 100%;
          height: 100%;
          z-index: 0;
        }
        .content {
          position: relative;
          z-index: 1;
          display: flex;
          flex-direction: column;
          align-items: center;
          padding-top: 69px;
          .title {
            color: #ffffff;
            font-size: 24px;
            font-weight: bold;
          }
          .rule,
          .range {
            color: #ffffff;
            font-size: 14px;
            text-decoration: underline;
            cursor: pointer;

            transition: all 0.2s;
          }
          .rule {
            margin-top: 69px;
          }
          .range {
            margin-top: 30px;
          }
        }
        &:hover {
          .content {
            .rule,
            .range {
              text-decoration: none;
              display: flex;
              justify-content: center;
              align-items: center;
              width: 232px;
              height: 34px;
              border-radius: 4px;
            }
            .rule {
              background: #f1f8ff;
              color: #1787e0;
              margin-top: 62px;
            }
            .range {
              background: #1787e0;
              margin-top: 16px;
            }
          }
        }
      }
    }
  }
  #zszz {
    position: relative;
    height: 480px;
    .bg {
      position: absolute;
      width: 100%;
      height: 480px;
      vertical-align: bottom;
    }
    .w1200 {
      position: relative;
      padding-top: 80px;
      & > img {
        position: absolute;
        width: 100%;
        height: 330px;
      }
      .info {
        position: relative;
        margin-left: 470px;
        margin-top: 57px;
        display: flex;
        flex-direction: column;
        p {
          color: #333333;
          font-size: 16px;
          margin-bottom: 13px;
        }
        ul {
          display: flex;
          flex-wrap: wrap;
          margin-bottom: 23px;
          li {
            display: flex;
            justify-content: center;
            align-items: center;
            width: 100px;
            height: 38px;
            background: #ffffff;
            border: 1px solid #e9e9e9;
            border-radius: 4px;
            box-sizing: border-box;
            font-size: 14px;
            color: #333333;
            cursor: pointer;
            &:not(:last-child) {
              margin-right: 14px;
            }
            &.on {
              border: 1px solid #1787e0;
              color: #1787e0;
            }
          }
        }
        input {
          width: 669px;
          height: 38px;
          background: #ffffff;
          border-radius: 4px;
          border: 1px solid #e9e9e9;
          padding: 9px 15px;
          box-sizing: border-box;
          outline: none;
        }
        a {
          display: flex;
          justify-content: center;
          align-items: center;
          width: 240px;
          height: 38px;
          margin-top: 26px;
          background: #1787e0;
          border-radius: 4px;
          color: #ffffff;
          font-size: 14px;
        }
      }
    }
  }
  .common-title {
    text-align: center;
    padding-top: 74px;
    padding-bottom: 50px;
    font-size: 26px;
    color: #333333;
    font-weight: bold;
    span {
      color: #1787e0;
    }
  }
  #bkzc {
    padding-bottom: 30px;
    .w1200 {
      ul {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        li {
          position: relative;
          margin-bottom: 30px;
          img {
            position: absolute;
            width: 100%;
            height: 100%;
            z-index: 0;
            cursor: pointer;
          }
          .sub-box {
            position: relative;
            z-index: 1;
            display: flex;
            flex-wrap: wrap;
            justify-content: center;
            margin-top: 75px;
            span {
              display: flex;
              justify-content: center;
              align-items: center;
              width: 142px;
              height: 38px;
              margin-bottom: 12px;
              background: #f1f8ff;
              border-radius: 4px;
              border: 1px solid #f1f8ff;
              cursor: pointer;
              &:not(:nth-child(2n)) {
                margin-right: 20px;
              }
              &:hover {
                border: 1px solid #1787e0;
                color: #1787e0;
              }
            }
          }
        }
      }
    }
  }
  .box3 {
    background: #f6f8fe;
    padding-bottom: 77px;
    .w1200 {
      display: flex;
      align-items: center;
      justify-content: space-between;
      .l-img {
        width: 646px;
        flex-shrink: 0;
      }
      .form {
        display: flex;
        flex-direction: column;
        width: 502px;
        padding: 36px 46px;
        box-sizing: border-box;
        background: #ffffff;
        box-shadow: 0px 2px 6px 1px rgba(231, 231, 231, 0.7);
        border-radius: 8px;
        border: 1px solid rgba(229, 229, 229, 0.49);
        p {
          color: #333333;
          font-size: 18px;
          font-weight: bold;
          margin-bottom: 24px;
        }
        .el-radio-group {
          margin-bottom: 33px;
        }
        input {
          width: 410px;
          height: 42px;
          background: #e9e9e9;
          border-radius: 4px;
          outline: none;
          border: none;
          padding-left: 14px;
        }
        a {
          display: flex;
          justify-content: center;
          align-items: center;
          width: 410px;
          height: 42px;
          margin-top: 26px;
          background: #1787e0;
          border-radius: 4px;
          border: 1px solid #1787e0;
          color: #ffffff;
          font-size: 14px;
        }
      }
    }
  }
  #zlxz {
    padding-bottom: 118px;
    .common-title {
      padding-bottom: 23px;
    }
    .hint {
      color: #333333;
      font-size: 16px;
      text-align: center;
      span {
        color: #f72424;
      }
    }
    .zl-form {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-top: 78px;
      & > img {
        width: 775px;
        height: 214px;
        flex-shrink: 0;
      }
      .r-box {
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 360px;
        height: 212px;
        background: #ffffff;
        box-shadow: 0px 2px 6px 1px rgba(231, 231, 231, 0.7);
        border-radius: 8px;
        border: 1px solid rgba(229, 229, 229, 0.49);
        & > img {
          width: 214px;
          height: 109px;
          margin-top: -27px;
        }
        input {
          width: 290px;
          height: 40px;
          margin-top: 16px;
          background: #e9e9e9;
          border-radius: 4px;
          outline: none;
          border: none;
          text-align: center;
        }
        a {
          display: flex;
          justify-content: center;
          align-items: center;
          width: 290px;
          height: 40px;
          margin-top: 12px;
          background: #1787e0;
          border-radius: 4px;
          color: #ffffff;
          font-size: 14px;
        }
      }
    }
  }
  .footer {
    display: flex;
    flex-direction: column;
    align-items: center;
    background: #333333;
    height: 240px;
    ul {
      display: flex;
      width: 100%;
      justify-content: center;
      margin-top: 87px;
      li {
        a {
          color: #ffffff;
          font-size: 14px;
          &:hover {
            color: #1787e0;
          }
        }
        span {
          color: #666666;
        }
      }
    }
    .line {
      width: 100%;
      height: 1px;
      margin-top: 54px;
      margin-bottom: 25px;
      background: #666666;
    }
    .copyright {
      display: flex;
      justify-content: center;
      a {
        color: #ffffff;
        font-size: 12px;
      }
    }
  }

  .submit-dialog {
    .submitMian {
      font-size: 18px;
      font-weight: 400;
      color: #333333;
      line-height: 28px;
      text-align: center;
    }

    .dialog-footer {
      button {
        width: 150px;
        height: 44px;
        background: #1787e0;
        border-radius: 22px;
        border: none;
        font-size: 20px;
        color: #ffffff;
        cursor: pointer;
      }
    }

    ::v-deep .el-dialog {
      border-radius: 22px;
    }
  }

  .zx-dialog {
    ::v-deep .el-dialog {
      .el-dialog__header {
        display: none;
      }
      .el-dialog__body {
        padding: 0;
      }
    }
    .content {
      position: relative;
      display: flex;
      flex-direction: column;
      align-items: center;
      width: 620px;
      height: 460px;
      .dialog-bg {
        position: absolute;
        width: 100%;
        height: 100%;
        z-index: 0;
      }
      .close {
        position: absolute;
        width: 28px;
        height: 28px;
        top: 0;
        right: 0;
        margin-top: 30px;
        margin-right: 30px;
        cursor: pointer;
      }
      h3 {
        position: relative;
        z-index: 1;
        padding-top: 60px;
        color: #1787e0;
        font-size: 26px;
        font-weight: bold;
      }
      .radio-box {
        position: relative;
        z-index: 1;
        width: 454px;
        height: 160px;
        padding: 39px 52px;
        margin-top: 42px;
        background: #ffffff;
        border-radius: 6px;
        border: 1px solid #1787e0;
        box-sizing: border-box;
        ::v-deep .el-radio {
          width: 86px;
          margin-bottom: 40px;
        }
      }
      .input-box {
        position: relative;
        z-index: 1;
        display: flex;
        align-items: center;
        margin-top: 30px;
        .name,
        .mobile {
          height: 44px;
          background: #ffffff;
          border-radius: 4px 4px 4px 4px;
          margin-right: 10px;
          outline: none;
          border: none;
        }
        .name {
          width: 106px;
          text-align: center;
        }
        .mobile {
          width: 210px;
          padding-left: 22px;
        }
        a {
          display: flex;
          justify-content: center;
          align-items: center;
          width: 120px;
          height: 44px;
          background: #1787e0;
          border-radius: 4px 4px 4px 4px;
          color: #ffffff;
          font-size: 14px;
        }
      }
      p {
        position: relative;
        z-index: 1;
        margin-top: 20px;
        font-size: 14px;
        color: #666666;
        span {
          color: #f72424;
        }
      }
    }
  }

  .notice-dialog {
    ::v-deep .el-dialog {
      .el-dialog__header {
        display: none;
      }
      .el-dialog__body {
        padding: 0;
      }
    }
    .content {
      position: relative;
      display: flex;
      flex-direction: column;
      align-items: center;
      width: 636px;
      height: 460px;
      .dialog-bg {
        position: absolute;
        width: 100%;
        height: 100%;
        z-index: 0;
      }
      .close {
        position: absolute;
        width: 28px;
        height: 28px;
        top: 0;
        right: 0;
        margin-top: 30px;
        margin-right: 30px;
        cursor: pointer;
      }
      h3 {
        position: relative;
        z-index: 1;
        padding-top: 55px;
        color: #1787e0;
        font-size: 26px;
        font-weight: bold;
      }
      .check-boxs {
        position: relative;
        z-index: 1;
        width: 582px;
        height: 140px;
        padding: 32px 10px;
        margin-top: 23px;
        background: #ffffff;
        border-radius: 6px;
        border: 1px solid #1787e0;
        box-sizing: border-box;
        .el-checkbox {
          margin-right: 13px;
          margin-bottom: 30px;
          span {
            display: inline-block;
            font-size: 16px;
            font-weight: bold;
            color: #e90000;
            position: relative;
            img {
              position: absolute;
              top: 0;
              right: 0;
              width: 47px;
              height: 36px;
              margin-top: -18px;
              margin-right: -43px;
            }
          }
          ::v-deep .el-checkbox__label {
            color: #333333;
          }
        }
      }
      .input-box {
        position: relative;
        z-index: 1;
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-top: 25px;
        .mobile {
          width: 410px;
          height: 44px;
          text-align: center;
          background: #ffffff;
          border-radius: 4px 4px 4px 4px;
          outline: none;
          border: none;
        }

        a {
          display: flex;
          justify-content: center;
          align-items: center;
          width: 175px;
          height: 44px;
          margin-top: 15px;
          background: #1787e0;
          border-radius: 4px 4px 4px 4px;
          color: #ffffff;
          font-size: 14px;
        }
      }
      p {
        position: relative;
        z-index: 1;
        margin-top: 15px;
        font-size: 12px;
        color: #000101;
        span {
          color: #fe0000;
        }
      }
    }
  }

  .hot-dialog {
    ::v-deep .el-dialog {
      border-radius: 16px;
      .el-dialog__header {
        display: none;
      }
      .el-dialog__body {
        padding: 0;
      }
    }
    .content {
      position: relative;
      display: flex;
      flex-direction: column;
      align-items: center;
      .top-img {
        width: 100%;
        height: 110px;
        border-radius: 16px 16px 0 0;
      }
      .close {
        position: absolute;
        top: 0;
        right: 0;
        width: 36px;
        height: 36px;
        margin-top: -36px;
        margin-right: -36px;
      }
      h3 {
        position: absolute;
        color: #ffffff;
        font-size: 26px;
        font-weight: bold;
        margin-top: 35px;
      }
      .input-box {
        display: flex;
        align-items: center;
        margin-bottom: 24px;
        color: #333333;
        font-size: 18px;
        font-weight: bold;
        input {
          width: 354px;
          height: 50px;
          padding-left: 14px;
          outline: none;
          border: none;
          background: #e9e9e9;
          border-radius: 6px 6px 6px 6px;
        }
      }
      p {
        font-size: 14px;
        color: #333333;
        padding-top: 18px;
        span {
          color: #f72424;
        }
      }
      a {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 408px;
        height: 54px;
        margin-top: 18px;
        margin-bottom: 38px;
        background: #1787e0;
        border-radius: 27px 27px 27px 27px;
        color: #ffffff;
        font-size: 16px;
      }
    }
  }
}
</style>
